module.exports = __webpack_public_path__ + "static/img/jbpt.52a29eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/appModule/bouncedMormApp/img/jbpt.jpg
// module id = Z/ZH
// module chunks = 1